module.exports = __webpack_public_path__ + "img/icon_style.5e8daafb.png";